export function normalizeSortLabel(value: unknown): string {
  return String(value ?? "").trim();
}

export function sortByLabel<T>(
  items: readonly T[] | undefined,
  getLabel: (item: T) => string,
  locale: string,
): T[] {
  if (!items) return [];

  const collator = new Intl.Collator(locale, {
    sensitivity: "base",
    numeric: true,
  });

  return [...items].sort((left, right) =>
    collator.compare(
      normalizeSortLabel(getLabel(left)),
      normalizeSortLabel(getLabel(right)),
    ),
  );
}

export function sortByName<T extends { name?: string | null }>(
  items: readonly T[] | undefined,
  locale: string,
): T[] {
  return sortByLabel(items, (item) => item.name ?? "", locale);
}
